/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgManageWorkDefinitions = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M9 2h4v2h-2v2.04l-.716.213a5.93 5.93 0 0 0-1.138.468l-.656.356-1.44-1.44L5.636 7.05l1.44 1.44-.355.656a5.93 5.93 0 0 0-.468 1.138L6.04 11H4v2h2.04l.213.716c.119.4.276.782.468 1.138l.356.656-1.44 1.44 1.413 1.414 1.44-1.44.656.355c.356.192.737.35 1.138.468l.716.213V20h2v2H9v-2.584a7.733 7.733 0 0 1-.123-.05L7.05 21.191 2.808 16.95l1.827-1.827a7.923 7.923 0 0 1-.05-.123H2V9h2.584l.05-.123L2.809 7.05 7.05 2.808l1.827 1.827.123-.05zm10 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 1 1 0 2h-1.635l-.963 1.444a2.999 2.999 0 0 1 0 5.111L14.535 16h1.636a3.001 3.001 0 1 1 0 2h-2.706l-2.036-3.054a3 3 0 0 1 0-5.892L13.465 6zM12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgManageWorkDefinitions as ManageWorkDefinitions };
